module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservation"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n                    " + _vm._s(_vm.reservation.name) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-7 col-sm-6"
  }, [_c('invoice', {
    attrs: {
      "id": _vm.reservation.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-5 col-sm-6"
  }, [_c('card', [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Reservation")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.name),
      expression: "reservation.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Type",
      "track-by": "label",
      "label": "label",
      "options": _vm.typeOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Room")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Room",
      "track-by": "label",
      "label": "label",
      "options": _vm.roomOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedRoom),
      callback: function($$v) {
        _vm.selectedRoom = $$v
      },
      expression: "selectedRoom"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.comment),
      expression: "reservation.comment"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.reservation.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.doubleBooking
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Arrival")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'YYYY-MM-DD'
      }
    },
    model: {
      value: (_vm.reservation.arrival.date),
      callback: function($$v) {
        _vm.$set(_vm.reservation.arrival, "date", $$v)
      },
      expression: "reservation.arrival.date"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.doubleBooking
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Departure")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'YYYY-MM-DD'
      }
    },
    model: {
      value: (_vm.reservation.departure.date),
      callback: function($$v) {
        _vm.$set(_vm.reservation.departure, "date", $$v)
      },
      expression: "reservation.departure.date"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Number of guests")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.guests),
      expression: "reservation.guests"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.guests)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "guests", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Breakfast")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Eating guests")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.numberOfBreakfasts),
      expression: "reservation.numberOfBreakfasts"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.numberOfBreakfasts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "numberOfBreakfasts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Total for all nights")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.totalPriceBreakfast),
      expression: "reservation.totalPriceBreakfast"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.totalPriceBreakfast)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "totalPriceBreakfast", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Update reservation")])])])])]), _vm._v(" "), _c('card', [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Invoice")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v("Print")])])]), _vm._v(" "), _c('card', [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Products")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('products', {
    attrs: {
      "id": _vm.reservation.id
    }
  })], 1), _vm._v(" "), _c('card', [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Delete reservation")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Delete this reservation")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "visible-print"
  }, [_c('invoice', {
    attrs: {
      "id": _vm.reservation.id
    }
  })], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-173dd330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reservations/View.vue
// module id = 384
// module chunks = 1